import { SpaceBetween } from "@cloudscape-design/components-themed";
import { useParams } from "react-router-dom";
import ApplicationInfo from "./ApplicationInfo";
import { useEffect, useState } from "react";
import Merchant from "./merchant/Merchant";
import Store from "./store/Store";
import Footer from "./Footer";
import { useGetIndividualHandlingConfirmationTargetQuery } from "../../features/api";
import {
  ConfirmationStoreInfo,
  ConfirmationMerchantInfo,
  ConfirmResult,
} from "../../features/api-interfaces";
import { useAppSelector } from "../../app/hook";
import { isEmpty, isNil, isNull, isEqual } from "lodash";
import { REQUIRED_INDIVIDUAL_COUNSELING_PROJECT_CONFIRMATION } from "./constants";
import { filteredStoreList } from "./util";

/**
 * 個別取扱確認更新
 */
const Main = () => {
  const { applicationNo } = useParams();
  const { searchCriteria } = useAppSelector(
    (state) => state.individualHandlingList
  );
  const [merchant, setMerchant] = useState<
    ConfirmationMerchantInfo | undefined
  >(undefined);
  const [storeList, setStoreList] = useState<
    ConfirmationStoreInfo[] | undefined
  >(undefined);
  const { data, refetch, isFetching } =
    useGetIndividualHandlingConfirmationTargetQuery(applicationNo as string, {
      skip: !applicationNo,
    });
  const isMerchantRegistered =
    data?.merchant?.merchantInfoList?.every(
      (item) => !isNull(item.confirmationResult)
    ) ?? true;
  const [confirmResultList, setConfirmResultList] = useState<ConfirmResult[]>(
    []
  );

  const registeredStoreList =
    data?.storeInfoList?.filter((store) => !isNull(store.confirmationResult)) ??
    [];
  const isStoreRegistered = isEmpty(data?.storeInfoList)
    ? true
    : data!.storeInfoList.every((store) => !isNull(store.confirmationResult));
  const isIndividualConsultation =
    !isEmpty(data?.merchant?.merchantInfoList) &&
    data!.merchant.merchantInfoList.some((item) =>
      isEqual(
        item.individualHandlingReason,
        REQUIRED_INDIVIDUAL_COUNSELING_PROJECT_CONFIRMATION
      )
    );

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    setMerchant(data?.merchant);
    if (data?.storeInfoList && 0 < data.storeInfoList.length) {
      resetStoreList();
    }

    const list = data?.merchant?.merchantInfoList.map((item) => ({
      individualHandlingReason: item.individualHandlingReason,
      confirmationResult: !isNil(item.confirmationResult),
    })) as ConfirmResult[];

    setConfirmResultList(list);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isFetching]);

  /**
   * APIから受け取った店舗リストを画面に表示する.
   */
  const resetStoreList = () =>
    setStoreList(filteredStoreList(data?.storeInfoList, searchCriteria));

  return (
    <SpaceBetween direction={"vertical"} size={"l"}>
      {data && (
        <ApplicationInfo
          data={data}
          isIndividualHandlingTarget={isIndividualConsultation}
        />
      )}
      {merchant && (
        <Merchant
          merchant={merchant}
          setMerchant={setMerchant}
          isMerchantRegistered={isMerchantRegistered}
          confirmResultList={confirmResultList}
        />
      )}
      {!isEmpty(storeList) && (
        <Store
          registeredStoreList={registeredStoreList}
          storeList={storeList ?? []}
          setStoreList={setStoreList}
          resetStoreList={resetStoreList}
        />
      )}
      <Footer
        applicationNo={applicationNo as string}
        searchCriteria={searchCriteria}
        isMerchantRegistered={isMerchantRegistered}
        merchant={merchant}
        registeredStoreList={registeredStoreList}
        storeList={storeList}
        disabledUpdateButton={
          (isStoreRegistered && isMerchantRegistered) || isFetching
        }
        disabledDownloadButton={
          (isNil(merchant) && isEmpty(storeList)) || isFetching
        }
        refetch={refetch}
      />
    </SpaceBetween>
  );
};

export default Main;
